import React from 'react';
import AuthLayout from 'components/auth/AuthLayout';
import ForceChangePasswordForm from 'components/auth/ForceChangePasswordForm';

const ForcePasswordChangePage = () => {
  return (<AuthLayout><ForceChangePasswordForm /></AuthLayout>);
}

export default ForcePasswordChangePage;
